function collectionItemsInit() {
  const collectionItems = document.querySelectorAll('[data-collection-item]');
  if (!collectionItems) { return; }
  collectionItems.forEach(item => {
    collectionItemInit(item);
  });
}

 function collectionItemInit(item) {
  const helpOpen = item.querySelector('[data-collection-item-help-toggle]');
  const helpClose = item.querySelector('[data-collection-item-help-close]');

  if (!helpOpen || !helpClose) { return; }

  helpOpen.addEventListener('click', () => {
    item.classList.add('flipped');
    item.classList.add('flipping');
    setTimeout(() => item.classList.remove('flipping'), 500);
  });

  helpClose.addEventListener('click', () => {
    item.classList.remove('flipped');
    item.classList.add('flipping');
    setTimeout(() => item.classList.remove('flipping'), 500);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  collectionItemsInit();
});


// how it works instructions 

function howItWorksTiles() {
  const openDetailsBtns = document.querySelectorAll('[data-how-it-works-instructions-open]');
  const closeDetailsBtns = document.querySelectorAll('[data-how-it-works-instructions-close]');

  openDetailsBtns.forEach((openDetailsBtn) => {
    openDetailsBtn.addEventListener('click', () => {
      const tile = openDetailsBtn.getAttribute('data-how-it-works-instructions-open');
      const innerTile = document.querySelector(`[data-how-it-works-instructions-inner-tile='${tile}']`);
      innerTile.classList.add('active');
    });
  });

  closeDetailsBtns.forEach((closeDetailsBtn) => {
    closeDetailsBtn.addEventListener('click', () => {
      const tile = closeDetailsBtn.getAttribute('data-how-it-works-instructions-close');
      const innerTile = document.querySelector(`[data-how-it-works-instructions-inner-tile='${tile}']`);
      innerTile.classList.remove('active');
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  howItWorksTiles();
});


// how it works faqs

function howItWorksFaqs() {
  const faqs = document.querySelectorAll('[data-how-it-works-faq]');
  const toggles = document.querySelectorAll('[data-how-it-works-faq-category-toggle]');

  toggleCategory(toggles[0]);

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      resetCategory();
      toggleCategory(toggle);
    });
  });

  faqs.forEach((faq) => {
    faq.addEventListener('click', () => {
      const answer = faq.querySelector('[data-how-it-works-faq-answer]');
      const plus = faq.querySelector('[data-how-it-works-faq-plus]');
      const minus = faq.querySelector('[data-how-it-works-faq-minus]');
      answer.classList.toggle('active');
      plus.classList.toggle('active');
      minus.classList.toggle('active');
    });
  });

  function toggleCategory(toggle) {
    const category = toggle.getAttribute('data-how-it-works-faq-category-toggle');
    document.querySelectorAll(`[data-how-it-works-faq='${category}']`).forEach((faq) => {
      toggle.classList.add('active');
      faq.classList.add('active');
    });
  }

  function resetCategory() {
    toggles.forEach((toggle) => {
      toggle.classList.remove('active');
    });

    faqs.forEach((faq) => {
      faq.classList.remove('active');
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  howItWorksFaqs();
});
